export default "<p>vouchers works!</p>\n";